import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Droplets, ShoppingCart, Scissors, Check, Gift, Zap, Target, Clock } from 'lucide-react';
interface BonusItemProps {
  text: string;
}
function BonusItem({
  text
}: BonusItemProps) {
  return <li className="flex items-start gap-3" data-id="element-12">
      <div className="w-5 h-5 rounded-full bg-olive/15 flex items-center justify-center shrink-0 mt-0.5" data-id="element-13">
        <Check className="w-3 h-3 text-olive" data-id="element-14" />
      </div>
      <span className="text-brown-800/80" data-id="element-15">{text}</span>
    </li>;
}
export function BonusSection() {
  const bonuses = [{
    icon: Droplets,
    number: 1,
    title: 'Kit SOS Anti‑Frizz',
    image: 'https://cdn.magicpatterns.com/uploads/nfPuebhd6kyWWcP2p6bARQ/bono_1.png',
    imageAlt: 'Kit SOS Anti-Frizz - Humedad & Clima',
    value: '$17',
    hook: 'Ese momento en que sales de casa y en 5 minutos el pelo se infla… es el que provoca compras impulsivas, frustración y vergüenza.',
    desc: 'Este bono es tu "plan de emergencia" para resolverlo en 3–5 minutos.',
    items: ['Tabla rápida de humedad alta / media / baja', 'Diagnóstico de frizz (halo, nube, resequedad, acumulación)', '3 protocolos SOS paso a paso (sin lavar, sin rehacer todo)', 'Atajos por textura 1A–4C', 'Checklist imprimible + tarjetas para guardar en el celular'],
    result: 'Sabes exactamente qué hacer hoy, según el clima, sin adivinar.',
    resultIcon: Target
  }, {
    icon: ShoppingCart,
    number: 2,
    title: 'Lista de Compras Inteligente 1A–4C',
    image: 'https://cdn.magicpatterns.com/uploads/2L1KmRZ1L4C7wEv8uvtKrT/bono_2.png',
    imageAlt: 'Lista de Compras Inteligente 1A-4C - Barato vs Mejor',
    value: '$15',
    hook: 'Si alguna vez compraste un producto "porque alguien lo recomendó" y terminó abandonado en tu baño… esto es para ti.',
    desc: 'Este bono te da una lista corta para comprar con criterio, según tu textura.',
    items: ['Kit mínimo (3–5 productos) por tipo de cabello', 'Opciones barato vs mejor con pros y contras', 'Matriz "si tu pelo hace X → compra Y"', 'Checklist "Compra en 5 minutos"', 'Tracker para registrar qué te funciona y dejar de gastar por ansiedad'],
    result: 'Compras menos, aciertas más, y tu rutina se vuelve repetible.',
    resultIcon: Zap
  }, {
    icon: Scissors,
    number: 3,
    title: 'Peinados Express "Me Veo Arreglada"',
    image: 'https://cdn.magicpatterns.com/uploads/s1n8XR7VxDNEVfCRxXZDiW/bono_3.png',
    imageAlt: 'Peinados Express Me Veo Arreglada - 5 Minutos por Textura',
    value: '$15',
    hook: 'Porque no todos los días son "día de rutina perfecta".',
    desc: 'Este bono es tu salvavidas para verte arreglada aunque tengas prisa, sueño o un "bad hair day".',
    items: ['20 peinados express (5 por textura 1A–4C)', 'Regla "Me veo pulida" en 60 segundos', 'Tabla "problema → peinado" (frizz, aplastado, reseco, sin forma)', 'Checklist + "mis 3 peinados salvavidas" para repetir toda la semana'],
    result: 'Te ves bien hoy, sin pelear con tu textura.',
    resultIcon: Clock
  }];
  return <section className="py-20 md:py-32 bg-cream-50" data-id="element-16">
      <div className="max-w-5xl mx-auto px-6" data-id="element-17">
        {/* Header */}
        <FadeIn className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-olive/10 text-olive text-sm font-medium tracking-wider mb-6" data-id="element-19">
            <Gift className="w-4 h-4" data-id="element-20" />
            BONOS INCLUIDOS GRATIS
          </div>
          <h2 className="text-3xl md:text-5xl font-serif text-brown-900 mb-4" data-id="element-21">
            Y si compras hoy, te llevas{' '}
            <span className="text-terracotta italic" data-id="element-22">GRATIS</span> estos 3 bonos
          </h2>
          <p className="text-lg text-brown-800/60 max-w-2xl mx-auto" data-id="element-23">
            No son "relleno". Son lo que hace que el sistema sea más fácil de
            seguir, más rápido de aplicar y más difícil de abandonar.
          </p>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="space-y-10" data-id="element-24">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-25">
              <div className="bg-white rounded-2xl shadow-sm border border-brown-900/5 overflow-hidden" data-id="element-26">
                {/* Bonus Header Bar */}
                <div className="bg-cream-100 px-6 py-4 flex items-center justify-between border-b border-brown-900/5" data-id="element-27">
                  <div className="flex items-center gap-3" data-id="element-28">
                    <div className="w-8 h-8 rounded-full bg-terracotta/10 flex items-center justify-center" data-id="element-29">
                      <bonus.icon className="w-4 h-4 text-terracotta" data-id="element-30" />
                    </div>
                    <span className="text-sm font-medium text-brown-900 tracking-wide" data-id="element-31">
                      BONO #{bonus.number} — GRATIS
                    </span>
                  </div>
                  <div className="flex items-baseline gap-2" data-id="element-32">
                    <span className="text-sm text-brown-800/40 line-through" data-id="element-33">
                      {bonus.value}
                    </span>
                    <span className="text-sm font-bold text-olive" data-id="element-34">$0</span>
                  </div>
                </div>

                <div className="p-6 md:p-8" data-id="element-35">
                  <div className="flex flex-col md:flex-row gap-8" data-id="element-36">
                    {/* Bonus Image */}
                    <div className="flex justify-center md:justify-start shrink-0" data-id="element-37">
                      <div className="w-[200px] md:w-[240px] rounded-xl overflow-hidden shadow-lg" data-id="element-38">
                        <img src={bonus.image} alt={bonus.imageAlt} className="w-full h-auto object-cover" data-id="element-39" />
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 space-y-5" data-id="element-40">
                      <h3 className="text-2xl font-serif font-bold text-brown-900" data-id="element-41">
                        {bonus.title}
                      </h3>

                      <p className="text-brown-800/70 italic" data-id="element-42">{bonus.hook}</p>

                      <p className="text-brown-900 font-medium" data-id="element-43">{bonus.desc}</p>

                      <div data-id="element-44">
                        <p className="text-sm font-medium text-brown-800/50 uppercase tracking-wider mb-3" data-id="element-45">
                          Dentro recibes:
                        </p>
                        <ul className="space-y-3" data-id="element-46">
                          {bonus.items.map((item, j) => <BonusItem key={j} text={item} data-id="element-47" />)}
                        </ul>
                      </div>

                      <div className="flex items-start gap-3 bg-cream-100 p-4 rounded-xl mt-4" data-id="element-48">
                        <bonus.resultIcon className="w-5 h-5 text-terracotta shrink-0 mt-0.5" data-id="element-49" />
                        <p className="text-brown-900 font-semibold" data-id="element-50">
                          Resultado:{' '}
                          <span className="font-normal text-brown-800/80" data-id="element-51">
                            {bonus.result}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Summary Table */}
        <FadeIn delay={0.5} className="mt-16" data-id="element-52">
          <div className="bg-white rounded-2xl shadow-sm border border-brown-900/5 overflow-hidden" data-id="element-53">
            <div className="bg-brown-900 text-cream-50 px-6 py-4" data-id="element-54">
              <h3 className="font-serif text-xl font-bold text-center" data-id="element-55">
                Resumen de Bonos — GRATIS HOY
              </h3>
            </div>
            <div className="divide-y divide-brown-900/5" data-id="element-56">
              {[{
              name: 'Bono #1: Kit SOS Anti‑Frizz',
              value: '$17'
            }, {
              name: 'Bono #2: Lista de Compras Inteligente 1A–4C',
              value: '$15'
            }, {
              name: 'Bono #3: Peinados Express (5 Minutos)',
              value: '$15'
            }].map((row, i) => <div key={i} className="flex items-center justify-between px-6 py-4" data-id="element-57">
                  <span className="text-brown-800" data-id="element-58">{row.name}</span>
                  <span className="text-brown-800/50 line-through text-sm" data-id="element-59">
                    {row.value}
                  </span>
                </div>)}
              <div className="flex items-center justify-between px-6 py-4 bg-cream-100" data-id="element-60">
                <span className="font-bold text-brown-900" data-id="element-61">
                  Valor total de bonos
                </span>
                <span className="font-bold text-brown-900 line-through" data-id="element-62">
                  $47
                </span>
              </div>
              <div className="flex items-center justify-between px-6 py-5 bg-olive/5" data-id="element-63">
                <span className="font-bold text-brown-900 text-lg" data-id="element-64">
                  Tu precio hoy
                </span>
                <span className="font-bold text-olive text-2xl" data-id="element-65">$0 GRATIS</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}